import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import { createClientLevel } from "../../../api/Services";

import {
  Form,
  Input,
  Button,
  message,
  Select,
  Spin,
  InputNumber,
  Switch,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { RxLayers } from "react-icons/rx";
import CustomBreadcrumb from "../../../components/breadcrumb/Breadcrumb";

import styles from "./NewClientLevel.module.scss";
const NewClientLevel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  const getBasePath = () => {
    if (location.pathname.startsWith('/commercial-intelligence')) {
      return '/commercial-intelligence/configuration/client-levels';
    }
    if (location.pathname.startsWith('/fidelity')) {
      return '/fidelity/clientlevels';
    }
    return '/promotions/clientlevels';
  };

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const {
        name,
        level,
        description,
        ruleType,
        ruleQuantity,
        accumulationFactor,
        active,
      } = values;

      const response = await createClientLevel({
        name,
        level,
        description,
        ruleType,
        ruleQuantity,
        accumulationFactor,
        active,
      });
      if (response) {
        message.success(t("Common-CreateSuccessMessage"));
        form.resetFields();
        navigate(getBasePath());
      } else message.error(t("Common-ErrorMessage"));

      setLoading(false);
    } catch (error) {
      message.error(t("Common-ValidationErrorMessage"));
    }
  };

  return loading ? (
    <Spin
      indicator={<LoadingOutlined className="ol-loading-spin-icon" />}
      delay={500}
    />
  ) : (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div>
          <CustomBreadcrumb
            items={[
              {
                icon: <RxLayers />,
                label: t("Common-ClientLevels"),
                path: getBasePath()
              },
              {
                label: t("Common-NewClientLevel"),
                isCurrentPage: true
              }
            ]}
          />
        </div>
        <div className={styles.actionButtonsWrapper}>
          <Button
            onClick={handleCreate}
            className={styles.saveButton}
            type="primary"
          >
            {t("Common-Add")}
          </Button>
        </div>
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.clientLevelInfoWrapper}>
          <Form
            name="newClientLevel"
            layout="vertical"
            initialValues={{ remember: true }}
            form={form}
            autoComplete="off"
            className={styles.newForm}
          >
            <div className={styles.sectionTitle}>{t("Common-BasicInformation")}</div>
            <div className={styles.itemWrapper}>
              <Form.Item
                className={styles.formItem}
                label={t("Common-Level")}
                name="level"
                rules={[
                  {
                    required: true,
                    message: t("Common-Level"),
                  },
                ]}
              >
                <InputNumber
                  className={styles.inputNumber}
                  placeholder={t("Common-Level")}
                />
              </Form.Item>
              <Form.Item
                className={styles.formItem}
                label={t("Common-Name")}
                name="name"
                rules={[
                  {
                    required: true,
                    message: t("Common-NameNotEntered"),
                  },
                ]}
              >
                <Input placeholder={t("Common-Name")} />
              </Form.Item>
            </div>
            <div className={styles.itemWrapper}>
              <Form.Item 
                className={styles.formItem}
                label={t("Common-Description")} 
                name="description"
              >
                <Input placeholder={t("Common-Description")} />
              </Form.Item>
              <Form.Item
                className={styles.formItem}
                label={t("Common-AccumulationFactor")}
                name="accumulationFactor"
                rules={[
                  {
                    required: true,
                    message: t("Common-AccumulationFactor"),
                  },
                ]}
              >
                <InputNumber
                  className={styles.inputNumber}
                  placeholder={t("Common-AccumulationFactor")}
                />
              </Form.Item>
            </div>
            <div className={styles.itemWrapper}>
              <Form.Item
                className={styles.formItem}
                initialValue={false}
                label={t("Common-Active")}
                name="active"
                rules={[
                  {
                    required: true,
                    message: t("Common-Active"),
                  },
                ]}
              >
                <Switch />
              </Form.Item>
              <div className={styles.formItem}></div>
            </div>
            
            <div className={styles.sectionTitle}>{t("Common-Rules")}</div>
            <div className={styles.itemWrapper}>
              <Form.Item 
                className={styles.formItem}
                label={t("Common-RuleType")} 
                name="ruleType"
              >
                <Select
                  allowClear
                  style={{ width: "100%" }}
                  placeholder={t("Common-RuleType")}
                >
                  <Select.Option value="ACCOUNT_POINTS">
                    {t("Common-AccountPoints")}
                  </Select.Option>
                  <Select.Option value="MONTHS_IN_PROGRAM">
                    {t("Common-MonthsInProgram")}
                  </Select.Option>
                  <Select.Option value="TOTAL_SPENT">
                    {t("Common-TotalSpent")}
                  </Select.Option>
                  <Select.Option value="AMMOUNT_SPENT">
                    {t("Common-AmmountSpent")}
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item 
                className={styles.formItem}
                label={t("Common-RuleQuantity")} 
                name="ruleQuantity"
              >
                <InputNumber
                  className={styles.inputNumber}
                  placeholder={t("Common-RuleQuantity")}
                />
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default NewClientLevel;
